/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import Navbar from "../components/Navbar/index";
import AppointmentForm from "../components/appointmentForm/index";
import Testimonial from "../components/Slider";
import divider from "../assets/images/divider.png";
import Offer from "../components/Offer/index";
import Disorder from "../components/disorderSection/index";
import Hero from "../components/Hero/index";

const Landingpage = () => {
  const descriptionRef = React.useRef(null);

  return (
    <div className="bg-white w-full">
      <div className="relative z-10">
        {" "}
        <Navbar toRef={descriptionRef} duration={1500} />
      </div>
      <Hero duration={1500} toRef={descriptionRef} toId="disorder" />
      <div id="disorder">
        <Disorder />
      </div>
      <div className="flex justify-center items-center pb-20">
        <img src={divider} alt="divider" />
      </div>
      <Offer />
      {/* <Testimonial /> */}
      <div className="lg:px-24 mt-20">
        <div className="flex flex-wrap">
          <div
            className="lg:w-3/5 w-full px-5 lg:px-10 text-text_color"
            ref={descriptionRef}
          >
            <AppointmentForm />
          </div>

          <div className="lg:w-2/5 w-full rounded-lg lg:px-10 px-5 pb-10">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d990.8451125654957!2d3.3765404!3d6.5995513!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b9245b93201db%3A0x861461e38bd34c4e!2sHeritage%20Men&#39;s%20Clinic%20Nigeria!5e0!3m2!1sen!2sng!4v1635980965956!5m2!1sen!2sng"
              className=" rounded-lg border-0"
              height="630"
              width="100%"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landingpage;
